module.exports = __webpack_public_path__ + "img/ics_f_whatsapp.ca55e813.svg";